import type { IconData } from '@stacksjs/iconify-core'

export const tt1x1: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 0h512v512H0z\"/><g fill-rule=\"evenodd\"><path fill=\"#e00000\" d=\"M371 512L0 1v510.7zM141 0l371 511V.2z\"/><path fill=\"#000001\" d=\"M22.2.2h94.9l374.5 511.3h-97.9z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default tt1x1
